import { CoachMatchingScreen } from '@/components/CoachMatchingScreen';

export default function CoachMatching() {
  return <CoachMatchingScreen />;
}
